<!-- 清单 -->
<template>
    <div class='inventory'>
        <el-form :model="form" ref="form" disabled>
            <div v-if="parentCodeType == $root.gc_category">
                <div>
                    <el-table border key="tableData1" :max-height="maxHeight" :data="form.tableData1"
                              :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                              tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                        <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                        <el-table-column label="报价类型" width="140px" fixed>
                            <template slot-scope="scope">
                                <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                                <span v-else>计入合价</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="标段" fixed width="140px"
                                         v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                         prop="segmentsNumber"/>
                        <el-table-column label="分部分项名称" width="140px" fixed="left" prop="subitemName"/>
                        <el-table-column label="工程项名称" width="140px" fixed="left" prop="matterName"/>
                        <el-table-column label="工作/工艺内容描述/规格型号参数" width="140px" fixed="left" prop="matterRequired"/>
                        <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand"/>
                        <el-table-column label="投标品牌" width="140px" prop="brandName"/>
                        <el-table-column label="数量" width="140px" prop="quantities"/>
                        <el-table-column label="单位" width="140px" prop="unitName"/>
                        <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                        <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                        <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                        <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                        <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                        <el-table-column label="备注" width="140px" prop="remarks"/>
                    </el-table>
                </div>
            </div>
            <div v-else-if="parentCodeType == $root.wzsb_category">
                <el-table :max-height="maxHeight" :highlight-current-row="false" border key="tableData3"
                          :data="form.tableData3" :header-cell-style="$root.tableHeaderStyle"
                          :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini"
                          style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="招标事项" width="140px" fixed="left" prop="matterName"/>
                    <el-table-column label="招标需求内容描述/材质工艺等要求/规格型号" width="140px" fixed="left" prop="matterRequired"/>
                    <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand"/>
                    <el-table-column label="投标品牌" width="140px" prop="brandName"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="单位" width="140px" prop="unitName"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.yxtg_category">
                <el-table border key="tableData4" :max-height="maxHeight" :data="form.tableData4"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="招标内容/需求" width="140px" fixed="left" prop="matterRequired"/>
                    <el-table-column label="区域/位置" width="140px" fixed="left" prop="areaLocations"/>
                    <el-table-column label="制作工艺（工艺及材料描述详细）/事项内容要求描述" width="140px" prop="matterDesc"/>
                    <el-table-column label="规格尺寸" width="140px" prop="speciificationSize"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="天数" width="140px" prop="dayAmount"/>
                    <el-table-column label="单位" width="140px" prop="unitName"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.wyfw_category">
                <div v-if="codeType == $root.wyfwba_category || codeType == $root.wyfwbj_category">
                    <el-table border key="tableData5" :max-height="maxHeight" :data="form.tableData5"
                              :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                              tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                        <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                        <el-table-column label="报价类型" width="140px" fixed>
                            <template slot-scope="scope">
                                <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                                <span v-else>计入合价</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="标段" fixed width="140px"
                                         v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                         prop="segmentsNumber"/>
                        <el-table-column label="分类索引" width="140px" prop="subitemName"/>
                        <el-table-column label="岗位人员要求" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.matterName">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="客用品/清洁用品/岗位用品需求" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.matterRequired">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="单位" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.unitName">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="岗位时间" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.postTime">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务时长(月)" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.serviceTime">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="岗位数量" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.quantities">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="工时不含税单价（元/小时/岗）" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled
                                           v-model="scope.row.unitHourAmountExclTax">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="不含税单价（元）" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled
                                           v-model="scope.row.unitAmountExclTax" @input="autoComputeSpec(scope.row)">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="税率（%）" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.taxRatio"
                                           @input="autoComputeSpec(scope.row)">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="含税单价（元）" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled
                                           v-model="scope.row.unitAmountWithTax">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="不含税合价（元）" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.amountExclTax"
                                           @input="autoCompute(scope.row)">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="含税合价（元）" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.amountWithTax"
                                           @input="autoCompute(scope.row)">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="140px" prop="remarks"/>
                        <el-table-column label="工时单价（元/小时/岗）" width="140px">
                            <template slot-scope="scope">
                                <div :class="{input_box:true}">
                                    <input type="text" class="input_block" disabled v-model="scope.row.hourlyUnitPrice">
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else>
                    <el-table border key="tableData6" :max-height="maxHeight" :data="form.tableData6"
                              :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                              tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                        <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                        <el-table-column label="报价类型" width="140px" fixed>
                            <template slot-scope="scope">
                                <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                                <span v-else>计入合价</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="标段" fixed width="140px"
                                         v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                         prop="segmentsNumber"/>
                        <el-table-column label="分类索引" width="140px" prop="subitemName"/>
                        <el-table-column label="服务事项" width="140px" fixed="left" prop="matterName"/>
                        <el-table-column label="服务内容要求描述" width="140px" prop="matterRequired"/>
                        <el-table-column label="服务频次" width="140px" prop="maintenanceFrequency"/>
                        <el-table-column label="设备/服务参数描述" width="140px" prop="matterDesc"/>
                        <el-table-column label="数量" width="140px" prop="quantities"/>
                        <el-table-column label="单位" width="140px" prop="unitName"/>
                        <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                        <el-table-column label="税率/服务费率（%）" width="140px" prop="taxRatio"/>
                        <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                        <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                        <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                        <el-table-column label="备注" width="140px" prop="remarks"/>
                    </el-table>
                </div>
            </div>

            <div v-else-if="parentCodeType == $root.wywb_category">
                <el-table border key="tableData7" :max-height="maxHeight" :data="form.tableData7"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="分类索引" width="140px" prop="subitemName"/>
                    <el-table-column label="服务事项" width="140px" fixed="left" prop="matterName"/>
                    <el-table-column label="服务内容要求描述" width="140px" prop="matterRequired"/>
                    <el-table-column label="服务频次" width="140px" prop="maintenanceFrequency"/>
                    <el-table-column label="设备/服务参数描述" width="140px" prop="matterDesc"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="单位" width="140px" prop="unitNaaddData1me"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率/服务费率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="空调主机（冷量）" width="140px" prop="conditionerHost" v-if="this.codeType == $root.wywb_kt_category"/>
                    <el-table-column label="高压柜/低压柜（KVA）" width="140px" prop="highLowVoltage" v-if="this.codeType == $root.wywb_pds_category"/>
                    <el-table-column label="建筑面积（㎡）" width="140px" prop="constructArea"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                    <el-table-column label="平米单价（元/平米）" width="140px" prop="unitPricePerSquare"/>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.sj_category">
                <el-table border key="tableData8" :max-height="maxHeight" :data="form.tableData8"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="设计阶段/设计内容/设计范围/设计深度/设计系统" width="140px" prop="matterName"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="单位" width="140px" prop="unitName"/>
                    <el-table-column label="设计面积（㎡）" width="140px" prop="designArea"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.gw_category">
                <el-table border key="tableData9" :max-height="maxHeight" :data="form.tableData9"
                          :header-cell-style="$root.tableHeaderStyle" :cell-style="$root.tableCellStyle"
                          tooltip-effect="light" size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="顾问阶段/顾问服务内容/顾问范围/顾问系统/项目" width="140px" fixed="left" prop="matterName"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="单位" width="140px" prop="unitName"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）/服务费率" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.xx_category">
                <el-table :highlight-current-row="false" border key="tableData10" :max-height="maxHeight"
                          :data="form.tableData10" :header-cell-style="$root.tableHeaderStyle"
                          :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini"
                          style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="招标事项" width="140px" fixed="left" prop="matterName"/>
                    <el-table-column label="招标需求内容描述/材质工艺等要求/服务内容" width="140px" fixed="left" prop="matterRequired"/>
                    <el-table-column label="规格型号尺寸" width="140px" prop="specificationServiceRequirements"/>
                    <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand"/>
                    <el-table-column label="投标品牌" width="140px" prop="brandName"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="单位" width="140px" prop="unitName"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                </el-table>
            </div>
            <div v-else-if="parentCodeType == $root.xz_category">
                <el-table :highlight-current-row="false" :max-height="maxHeight" border key="tableData11"
                          :data="form.tableData11" :header-cell-style="$root.tableHeaderStyle"
                          :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini"
                          style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" fixed="left" width="100px" prop="rownumber"/>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="招标事项" width="140px" fixed="left" prop="matterName"/>
                    <el-table-column label="招标需求内容描述/材质工艺等要求" width="140px" fixed="left" prop="matterRequired"/>
                    <el-table-column label="规格型号尺寸" width="140px" prop="specificationServiceRequirements"/>
                    <el-table-column label="投标推荐品牌" width="140px" prop="recommendBrand"/>
                    <el-table-column label="投标品牌" width="140px" prop="brandName"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="单位" width="140px" prop="unitName"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                </el-table>
            </div>
            <div v-else>
                <el-table :highlight-current-row="false" :max-height="maxHeight" border key="tableData12"
                          :data="form.tableData12" :header-cell-style="$root.tableHeaderStyle"
                          :cell-style="$root.tableCellStyle" tooltip-effect="light" size="mini"
                          style="width: 100%;margin-top: 20px;">
                    <el-table-column label="序号" type="index" fixed="left" width="100px">
                        <template slot-scope="scope">
                            <el-form-item>
                                {{ scope.$index + 1 }}
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价类型" width="140px" fixed>
                        <template slot-scope="scope">
                            <span v-if="scope.row.quotationType == '2'">不计入合价</span>
                            <span v-else>计入合价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标段" fixed width="140px"
                                     v-if="pageType != 'buyDemand' && type != 2 && pageType != 'onlySupplier'"
                                     prop="segmentsNumber"/>
                    <el-table-column label="招标事项" width="140px" fixed="left" prop="matterName"/>
                    <el-table-column label="招标需求内容描述/材质工艺等要求/品牌规格型号" width="140px" fixed="left" prop="matterRequired"/>
                    <el-table-column label="数量" width="140px" prop="quantities"/>
                    <el-table-column label="单位" width="140px" prop="unitName"/>
                    <el-table-column label="不含税单价（元）" width="140px" prop="unitAmountExclTax"/>
                    <el-table-column label="税率（%）" width="140px" prop="taxRatio"/>
                    <el-table-column label="含税单价（元）" width="140px" prop="unitAmountWithTax"/>
                    <el-table-column label="不含税合价（元）" width="140px" prop="amountExclTax"/>
                    <el-table-column label="含税合价（元）" width="140px" prop="amountWithTax"/>
                    <el-table-column label="备注" width="140px" prop="remarks"/>
                </el-table>
            </div>
        </el-form>
        <div style="text-align: right;padding: 20px 0">
            <el-pagination
                background
                @current-change="this.handlePageChange"
                :current-page="this.pageNumber"
                :page-sizes="$root.pageSizesArr"
                :page-size="50"
                layout="total, prev, pager, next, jumper"
                :total="this.inv_count">
            </el-pagination>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'

export default Vue.component('inventory_BigData', {
    components: {},
    props: {
        code: {
            type: String,
        },
        parentCode: {
            type: String,
        },
        page: {
            type: String,
        },
        taxRatioFlag: {
            type: Number,
        },
        segments: {
            type: Number,
        },
        type: {
            type: Number,
        },
        maxHeight: {
            type: Number,
            default: 500,
        },
        inventory1: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        code(val) {
            this.codeType = val;
        },
        page(val) {
            this.pageType = val;
        },
        taxRatioFlag(val) {
            this.taxRatioMethod = val;
        },
        quotationFlag(val) {
            this.quotationMethod = val;
        },
        parentCode(val) {
            this.parentCodeType = val;
        },
    },
    data() {
        return {
            inv_count: 0,
            pageNumber: 1,
            codeType: '',
            parentCodeType: '',
            pageType: '',
            taxRatioMethod: '',
            quotationMethod: '',
            segmentsNumber: '',
            dealId: '',
            flowFormId: '',
            form: {
                tableData1: [{
                    subitemName: '',//分部分项名称
                    matterName: '',//工程项名称
                    matterRequired: '', //工作/工艺内容描述/规格型号参数
                    recommendBrand: '',//投标推荐品牌
                    brandName: '', //投标品牌
                    constructArea: '',//建筑面积（㎡）
                    serviceRenovationArea: '', //改造面积（㎡）
                    unitName: '', //单位
                    quantities: '', //数量
                    supplyUnitPrice: '', //供应单价（元）
                    installUnitPrice: '', //安装单价（元）
                    unitAmountExclTax: '', //不含税综合单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税综合单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
                tableData2: [{
                    subitemName: '',//分部分项名称
                    matterName: '',//工程项名称
                    matterRequired: '', //工作/工艺内容描述/规格型号参数
                    recommendBrand: '',//投标推荐品牌
                    brandName: '', //投标品牌
                    constructArea: '',//建筑面积（㎡）
                    serviceRenovationArea: '', //改造面积（㎡）
                    unitName: '', //单位
                    quantities: '', //数量
                    supplyUnitPrice: '', //供应单价（元）
                    installUnitPrice: '', //安装单价（元）
                    unitAmountExclTax: '', //不含税综合单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税综合单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                    listPurpose: '2'
                }],
                tableData3: [{
                    matterName: '',//招标事项
                    matterRequired: '', //招标需求内容描述/材质工艺等要求/规格型号
                    //speciificationSize:'',//规格尺寸
                    brandName: '', //品牌
                    quantities: '', //数量
                    unitName: '', //单位
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
                tableData4: [{
                    matterName: '',//合同编号
                    matterRequired: '', //招标内容/需求
                    areaLocations: '', //区域/位置
                    // attachements: [], //示意图片
                    matterDesc: '',//制作工艺（工艺及材料描述详细）/事项内容要求描述
                    speciificationSize: '',//规格尺寸
                    brandName: '', //品牌
                    quantities: '', //数量/天数
                    unitName: '', //单位
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
                tableData5: [{
                    matterName: '',//岗位人员要求
                    matterRequired: '', //客用品/清洁用品/岗位用品需求
                    constructArea: '',//建筑面积（㎡）
                    unitName: '', //单位
                    quantities: '', //岗位数量
                    postTime: '',//岗位时间
                    unitHourAmountExclTax: '', //工时不含税单价（元/小时/岗）
                    unitAmountExclTax: '', //不含税单价（元/岗）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元/岗）
                    monthlyAmountExclTax: '',//月度不含税合价（元）
                    monthlyAmountWithTax: '', //月度含税合价（元）
                    yearlyAmountExclTax: '',//年度不含税合价（元/年）
                    yearlyAmountWithTax: '',//年度含税合价（元/年）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                    hourlyUnitPrice: '',//工时单价（元/小时/岗）
                    postPerConstructArea: '', //岗位均建筑面积（㎡/岗）
                }],
                tableData6: [{
                    matterName: '',//服务事项
                    matterRequired: '', //服务内容要求描述
                    maintenanceFrequency: '',//服务频次
                    matterDesc: '', //设备/服务参数描述
                    quantities: '', //数量
                    unitName: '', //单位
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率/服务费率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    conditionerHost: '',//空调主机（冷量）
                    highLowVoltage: '', //高压柜/低压柜（KVA）

                    remarks: '',//备注
                    hourlyUnitPrice: '',//工时单价（元/小时/岗）
                    postPerConstructArea: '', //岗位均建筑面积（㎡/岗）
                    constructArea: '',//建筑面积
                    unitPricePerSquare: '',//平米单价（元/平米）
                }],
                tableData7: [{
                    matterName: '',//服务事项
                    matterRequired: '', //服务内容要求描述
                    maintenanceFrequency: '',//服务频次
                    matterDesc: '', //设备/服务参数描述
                    quantities: '', //数量
                    unitName: '', //单位
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率/服务费率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    conditionerHost: '',//空调主机（冷量）
                    highLowVoltage: '', //高压柜/低压柜（KVA）

                    remarks: '',//备注
                    // hourlyUnitPrice: '',//工时单价（元/小时/岗）
                    // postPerConstructArea: '', //岗位均建筑面积（㎡/岗）
                    constructArea: '',//建筑面积
                    unitPricePerSquare: '',//平米单价（元/平米）
                }],
                tableData8: [{
                    matterName: '',//设计阶段/设计内容/设计范围/设计深度/设计系统
                    quantities: '', //数量
                    unitName: '', //单位
                    constructArea: '',//建筑面积
                    designArea: '',//设计面积
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
                tableData9: [{
                    matterName: '',//顾问阶段/顾问服务内容/顾问范围/顾问系统/项目
                    quantities: '', //数量
                    unitName: '', //单位
                    serviceFeeRatio: '', //服务费率
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
                tableData10: [{
                    matterName: '',//招标事项
                    matterRequired: '',//招标需求内容描述/材质工艺等要求/服务内容
                    quantities: '', //数量
                    brandName: '',//品牌
                    specificationServiceRequirements: '', //规格型号尺寸/服务要求
                    unitName: '', //单位
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
                tableData11: [{
                    matterName: '',//招标事项
                    matterRequired: '',//招标需求内容描述/材质工艺等要求
                    quantities: '', //数量
                    brandName: '',//品牌
                    specificationServiceRequirements: '', //规格型号尺寸
                    unitName: '', //单位
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
                tableData12: [{
                    matterName: '',//招标事项
                    matterRequired: '',//招标需求内容描述/材质工艺等要求/品牌规格型号
                    quantities: '', //数量
                    unitName: '', //单位
                    unitAmountExclTax: '', //不含税单价（元）
                    taxRatio: '', //税率（%）
                    unitAmountWithTax: '',//含税单价（元）
                    amountExclTax: '',//不含税合价（元）
                    amountWithTax: '',//含税合价（元）
                    remarks: '',//备注
                }],
            }
        }
    },
    //方法集合
    methods: {
        handlePageChange(val) {
            this.pageNumber = val;
            this.pageData();
        },
        pageData() {
            let that = this;
            let url = this.$root.qing_dan_page_url;
            console.log("this.pageType", this.pageType);
            if (this.pageType == 'listApprove1') {
                url = '/v1/wFlowFormEventAdjustments/getWFlowFormListPage'
                this.dataTypeFlag = 1
            } else if (this.pageType == 'listApprove2') {
                url = '/v1/wFlowFormEventAdjustments/getWFlowFormListPage'
                this.dataTypeFlag = 2
            }
            this.listType = null;
            if (this.pageType == 'buyDemand' || this.pageType == 'bidOpen' || this.pageType == 'onlySupplier') {
                this.listType = '1';
            } else if (this.pageType == 'tenderPriceEdit' || this.pageType == 'tenderEdit' || this.pageType == 'tenderListEdit') {
                this.listType = '2';
            }
            if (this.pageType == 'bidBack') {
                this.extranet = 1;
            } else if (this.pageType == 'businessNegotiation') {
                this.extranet = 2;
            } else {
                this.extranet = 0;
            }

            let params = {
                "flowFormId": this.flowFormId,
                "listType": this.listType,
                "pageNumber": this.pageNumber,
                "listPurpose": '1',
                "pageSize": 50,
                "pageFlag": '1',
                "dealId": this.dealId,
                "dataTypeFlag": this.dataTypeFlag,
                "extranet": this.extranet,
            };
            this.$root.postFunc(url, params, function (res) {
                that.setData(res.data.data || res.data, null)
            })
        },
        setData(listPage, obj) {
            let list1 = [];
            if (listPage) {
                this.pageNumber = listPage.current;
                this.inv_count = listPage.total;
                list1 = listPage.records || [];
            }
            if (obj) {
                this.flowFormId = obj.flowFormId;
                this.parentCodeType = obj.parentCategoryCode;
                this.codeType = obj.categoryCode;
                this.taxRatioMethod = obj.taxRatioMethod;
                this.quotationMethod = obj.quotationMethod;
                this.dealId = obj.dealId;
            }
            list1.forEach(item => {
                if (!item.segmentsNumber) {
                    item.segmentsNumber = 1;
                }

                // 清单数量、金额小数点控制
                if (item.quantities && item.quantities != 0) item.quantities = parseFloat(item.quantities).toFixed(3)
                if (item.unitAmountExclTax && item.unitAmountExclTax != 0) item.unitAmountExclTax = parseFloat(item.unitAmountExclTax).toFixed(2)
                if (item.unitAmountWithTax && item.unitAmountWithTax != 0) item.unitAmountWithTax = parseFloat(item.unitAmountWithTax).toFixed(2)
                if (item.amountExclTax && item.amountExclTax != 0) item.amountExclTax = parseFloat(item.amountExclTax).toFixed(2)
                if (item.amountWithTax && item.amountWithTax != 0) item.amountWithTax = parseFloat(item.amountWithTax).toFixed(2)
            });
            if (this.parentCodeType == this.$root.gc_category) {
                this.form.tableData1 = list1;
            } else if (this.parentCodeType == this.$root.wzsb_category) {
                this.form.tableData3 = list1;
            } else if (this.parentCodeType == this.$root.yxtg_category) {
                this.form.tableData4 = list1;
            } else if (this.parentCodeType == this.$root.wyfw_category) {
                if (this.codeType == this.$root.wyfwba_category || this.codeType == this.$root.wyfwbj_category) {
                    this.form.tableData5 = list1;
                } else {
                    this.form.tableData6 = list1;
                }
            } else if (this.parentCodeType == this.$root.wywb_category) {
                this.form.tableData7 = list1;
            } else if (this.parentCodeType == this.$root.sj_category) {
                this.form.tableData8 = list1;
            } else if (this.parentCodeType == this.$root.gw_category) {
                this.form.tableData9 = list1;
            } else if (this.parentCodeType == this.$root.xx_category) {
                this.form.tableData10 = list1;
            } else if (this.parentCodeType == this.$root.xz_category) {
                this.form.tableData11 = list1;
            } else {
                this.form.tableData12 = list1;
            }
        },
    },
    created() {
        this.quotationMethod = this.quotationFlag;
        this.taxRatioMethod = this.taxRatioFlag;
        this.pageType = this.page;
        this.codeType = this.code;
        this.parentCodeType = this.parentCode;
        this.segmentsNumber = this.segments;
    },
    mounted() {
        this.form.tableData1 = [];
        this.form.tableData2 = [];
        this.form.tableData3 = [];
        this.form.tableData4 = [];
        this.form.tableData5 = [];
        this.form.tableData6 = [];
        this.form.tableData7 = [];
        this.form.tableData8 = [];
        this.form.tableData9 = [];
        this.form.tableData10 = [];
        this.form.tableData11 = [];
        this.form.tableData12 = [];
    }
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
@import '../../../assets/_var.scss';

#el-table-column {
    width: 140px;
}

.inventory /deep/ {
    margin-top: -15px;

    .el-input__inner {
        border: 1px solid #C4C4C4 !important;
        border-radius: 3px !important;
    }

    .el-form-item {
        margin-bottom: 0px;
    }

    .el-form-item.is-error .el-input__inner {
        border-color: #f56c6c !important;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .el-form-item__content {
        line-height: 34px;
    }

    .el-table--mini th, .el-table--mini td {
        padding: 0px;
    }
}

.el-table td .cell {
    padding: 0;
}

/deep/ .inventory .el-input__inner {
    border: none !important;
}

.el-form-item.is-error {
    border: 1px solid #dd2727;
    position: absolute;
    left: -1px;
    right: 0px;
    top: -1px;
    width: calc(100% + 2px);
    background-color: #fff;
}

.el-table__body tr:first-child .el-form-item.is-error, .el-table__body tr:first-child .input_box.error_box {
    top: 0px;
}

.el-table__body tr td:nth-child(2) .el-form-item.is-error, .el-table__body tr td:nth-child(2) .input_box.error_box {
    left: 0px;
}

.container .el-form-item__error {
    display: none;
}

/deep/ .el-table__body tr.hover-row > td {
    background-color: #ecf5ff !important
}

/deep/ .el-table__body tr.hover-row > td {
    background-color: transparent;
}

.input_box {
    position: absolute;
    left: -1px;
    right: -1px;
    top: -1px;
    bottom: -1px;
}

.el-table__body tr:last-child .input_box.error_box {
    bottom: 1px;
}

.input_box.error_box {
    border: 1px solid #dd2727;
}

.input_block {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border: none;
    line-height: 33px;
    height: 33px;
    padding: 0 10px;
    background-color: transparent;
}

.input_block:focus {
    outline: none;
    border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/bid/components/inventory_BigData.vue